import chi_tiet_dat_ban from '../models/chi_tiet_dat_ban';
import request from './request';

export type TienDoTheoBan = {
  ban_id: number;
  ten_ban: string;
  gio_vao_ban: string | null;
  so_luong_hoan_tat: number;
  so_luong_dang_che_bien: number;
  tong_so_luong: number;
};

type GetMonAnChoBepResponse = {
  success: boolean;
  message?: string;
  chiTietDatBans?: chi_tiet_dat_ban[];
  tienDoTheoBan?: TienDoTheoBan[];
};

type BatDauCheBienResponse = {
  success: boolean;
  message?: string;
  chiTietDatBan?: chi_tiet_dat_ban;
};

type HoanTatCheBienResponse = {
  success: boolean;
  message?: string;
  chiTietDatBan?: chi_tiet_dat_ban;
};

const quanLyBepService = {
  getMonAnChoBep: async (): Promise<{ orders: chi_tiet_dat_ban[]; tableProgress: TienDoTheoBan[] }> => {
    const response = await request.get<GetMonAnChoBepResponse>('user-sale-get-mon-an-cho-bep');
    const result = response.data;

    if (!result.success) {
      throw new Error(result.message || 'Không thể tải danh sách món ăn cho bếp');
    }

    if (!Array.isArray(result.chiTietDatBans)) {
      throw new Error('Dữ liệu món ăn cho bếp không hợp lệ');
    }

    if (!Array.isArray(result.tienDoTheoBan)) {
      throw new Error('Dữ liệu tiến độ món ăn theo bàn không hợp lệ');
    }

    return { orders: result.chiTietDatBans, tableProgress: result.tienDoTheoBan };
  },
  getMonAnDaCheBienXong: async (): Promise<chi_tiet_dat_ban[]> => {
    const response = await request.get<GetMonAnChoBepResponse>('user-sale-get-mon-an-da-che-bien-xong');
    const result = response.data;

    if (!result.success) {
      throw new Error(result.message || 'Không thể tải danh sách món đã chế biến xong');
    }

    if (!Array.isArray(result.chiTietDatBans)) {
      throw new Error('Dữ liệu món đã chế biến xong không hợp lệ');
    }

    return result.chiTietDatBans;
  },
  batDauCheBien: async (chiTietDatBanId: number): Promise<chi_tiet_dat_ban> => {
    const response = await request.post<BatDauCheBienResponse>('user-sale-bat-dau-che-bien', {
      chi_tiet_dat_ban_id: chiTietDatBanId,
    });
    const result = response.data;

    if (!result.success || !result.chiTietDatBan) {
      throw new Error(result.message || 'Không thể cập nhật trạng thái món ăn');
    }

    return result.chiTietDatBan;
  },
  hoanTatCheBien: async (chiTietDatBanId: number): Promise<chi_tiet_dat_ban> => {
    const response = await request.post<HoanTatCheBienResponse>('user-sale-hoan-tat-che-bien', {
      chi_tiet_dat_ban_id: chiTietDatBanId,
    });
    const result = response.data;

    if (!result.success || !result.chiTietDatBan) {
      throw new Error(result.message || 'Không thể đánh dấu món đã chế biến xong');
    }

    return result.chiTietDatBan;
  },
};

export default quanLyBepService;
